import { combineReducers } from "@reduxjs/toolkit";
import UserReducer from "../slices/userSlice";

export default combineReducers({
    user: UserReducer,
});